module.exports = __webpack_public_path__ + "img/Melker.f89d927e.jpg";